module.exports = __webpack_public_path__ + "img/gp.11614fc4.svg";